import { useState } from 'react'

import { MChatConfirmAvaliacaoModal } from './MChatConfirmAvaliacaoModal'

interface MChatModalGuardProps {
  hasConsultaSeguimentoAtual: boolean
  children: JSX.Element
  onClose: () => void
}

export function MChatModalGuard(props: Readonly<MChatModalGuardProps>) {
  const { hasConsultaSeguimentoAtual, children, onClose } = props

  const [confirmed, setConfirmed] = useState(!hasConsultaSeguimentoAtual)

  if (!confirmed) {
    return <MChatConfirmAvaliacaoModal onConfirm={() => setConfirmed(true)} onCancel={onClose} />
  }

  return children
}
